export default "__VITE_ASSET__CKx5EN7K__"